import { types } from './actions';

const initialState = {
  isQuickbooksConnected: false,
  quickbooksError: null,
  quickbooksUrl: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_QUICKBOOKS_INFO_SUCCESS:
      return {
        ...state,
        isQuickbooksConnected: payload.connected,
        quickbooksError: payload.error,
        quickbooksUrl: payload.url,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.integrations.quickbooks;

export const getIsQuickbooksConnected = (state) =>
  getScope(state).isQuickbooksConnected;

export const getQuickbooksError = (state) => getScope(state).quickbooksError;

export const getQuickbooksUrl = (state) => getScope(state).quickbooksUrl;
